/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LegalDocumentsLayout.vue?vue&type=template&id=41611c12"
import script from "./LegalDocumentsLayout.vue?vue&type=script&lang=ts"
export * from "./LegalDocumentsLayout.vue?vue&type=script&lang=ts"
import style0 from "./LegalDocumentsLayout.vue?vue&type=style&index=0&id=41611c12&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports